import request from '@/util/request';
import qs from 'qs';

// 分页
export const getPageListApi = (params, options) =>
  request.get('/api/v4ward/callcenter/book/page', Object.assign({}, options, { params }));

// 新增
export const addApi = (params, options) =>
  request.post('/api/v4ward/callcenter/book/save', params, options, {
    ContentType: 'application/json',
  });

// 修改
export const updateApi = (params, options) =>
  request.post('/api/v4ward/callcenter/book/update', params, options, {
    ContentType: 'application/json',
  });

// 删除
export const removeApi = (params, options) =>
  request.post('/api/v4ward/callcenter/book/remove', qs.stringify(params), options);
